export default __webpack_public_path__ + "static/media/WeatherReporting_04.a44b63df.png";